export default __webpack_public_path__ + "static/media/img-card-02.f9908136.jpg";